import React from "react";
import { useTranslation } from "react-i18next";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { ArrowRight, TrendingDown, Trophy } from "lucide-react";

export function HowScoringModal({ open, onOpenChange }) {
  const { t } = useTranslation();
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="how-scoring-modal" className="max-w-lg bg-neutral-950 border-neutral-800">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl uppercase tracking-wide">{t("common.howScoringWorks")}</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 text-sm">
          <div className="flex gap-3">
            <div className="mt-0.5 text-[#b6ff2e]"><ArrowRight size={18} /></div>
            <p className="text-neutral-300">{t("onboard.s2title")} {t("onboard.s2body")}</p>
          </div>
          <div className="flex gap-3">
            <div className="mt-0.5 text-[#ffb547]"><TrendingDown size={18} /></div>
            <div className="text-neutral-300">
              <p className="mb-2">
                Lost Goal Difference (LGD) = the best possible XI's expected goal difference minus yours. It is measured in goals. Lower is better.
              </p>
              <div className="mono text-xs bg-neutral-900 border border-neutral-800 rounded-lg p-3 text-neutral-400">
                LGD = E[GD](optimal) − E[GD](your XI) ≥ 0
              </div>
            </div>
          </div>
          <div className="flex gap-3">
            <div className="mt-0.5 text-[#3fd7e5]"><Trophy size={18} /></div>
            <p className="text-neutral-300">{t("onboard.s3body")}</p>
          </div>
          <div className="grid grid-cols-3 gap-2 pt-2">
            {[["you", "#b6ff2e", t("common.you")], ["coach", "#ffb547", t("common.coach")], ["ai", "#3fd7e5", t("common.ai")]].map(([k, c, label]) => (
              <div key={k} className="rounded-lg border border-neutral-800 p-2 text-center">
                <div className="w-3 h-3 rounded-full mx-auto mb-1" style={{ background: c }} />
                <div className="text-xs text-neutral-300">{label}</div>
              </div>
            ))}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
